<template>
<div>
  <!-- 下拉框转换输入框组件 -->
  <!-- 使用方法 -->
  <!-- 1.传入指定的数组 :SelectArr -->
  <!-- 2.传入指定的选中值 :SelectValue -->
  <!-- 3.(可选)传入指定宽度 :widths -->
  <!-- 4.(可选)index 索引值，当需要多个组件是传入，返回当前修改的索引 -->
  <!-- 5.父组件传入GetSelectValue方法，返回参数props -->
  <!-- 6.转换成输入框时回车或失去焦点触发,为下拉框时改变选中值会触发 -->
    <el-select
          :placeholder="$t('lang.ConfigSetting.pleaseChoose')"
          v-model="DataSelectValue"
          size="mini"
          class="Form-Input-Width"
          @change="showInput(DataSelectValue)"
          v-show="!showInputValue"
          :style="{'width':widths?widths+'rem':'5rem'}"
        >
          <el-option v-for="item in SelectArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input
          size="mini"
          class="Form-Input-Width"
          v-model="modifySelectValue"
          v-if="showInputValue"
          @blur="noneInput"
          @keyup.enter.native="noneInput"
          v-focus>
        </el-input>
</div>  
</template>
<script>
export default {
  // (SelectArr为下拉框参数,SelectValue为当前选中值,widths为组件宽度)
  props:['SelectArr','SelectValue','widths','index'],
  data(){
    return{
      //自定义输入框的值
      modifySelectValue:'',
      //下拉框改变成输入框控制参数
      showInputValue: false,
      //接受父组件传过来的值
      DataSelectValue:this.SelectValue,
      myInputTpe: ''
    }
  },
  methods:{
    //选择自定义显示输入框
    showInput(value) {
      if (value === "自定义") {
        this.showInputValue = true;
      }
      if(value!=='自定义'){     
        console.log('DataSelectValue');   
        console.log(this.DataSelectValue);
        this.$emit('GetSelectValue',this.DataSelectValue,this.index)
      }
      // console.log(value)
    },
    //输入框失去焦点回复下拉框并赋值
    noneInput() {
      this.showInputValue = false
      //自定义选项赋值
      this.DataSelectValue=this.modifySelectValue
      this.$emit('GetSelectValue',this.DataSelectValue,this.index)
    },
  },
  watch:{
    SelectValue:{
      handler(newValue,oloValue){
        if(oloValue===undefined&&newValue){
          this.DataSelectValue=newValue
        }
      },
      deep: true
    },
  },
  directives: {
  focus: {
    //自定义获取焦点指令
    inserted: function (el) {
      el.querySelector('input').focus()
    }
  }
  }
}
</script>
<style scoped>
.Form-Input-Width {
  width: 5rem;
}
</style>
